"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_i18next_1 = require("react-i18next");

var react_web_components_1 = require("@nimles/react-web-components");

var fields_1 = require("../fields");

exports.OrganizationForm = function (_a) {
  var organization = _a.organization,
      onSubmit = _a.onSubmit,
      includeUser = _a.includeUser;
  var values = {
    firstName: organization && organization.firstName || '',
    lastName: organization && organization.lastName || '',
    username: organization && organization.username || '',
    password: organization && organization.password || '',
    name: organization && organization.name || '',
    corporateIdentity: organization && organization.corporateIdentityprops || '',
    description: organization && organization.description || '',
    organization: {
      address: {
        street: organization && organization.address && organization.address.street || '',
        city: organization && organization.address && organization.address.city || '',
        postalCode: organization && organization.address && organization.address.postalCode || ''
      }
    },
    phoneNumber: organization && organization.phoneNumber || ''
  };
  var t = react_i18next_1.useTranslation().t;

  var handleSubmit = function handleSubmit(values, _a) {
    var setSubmitting = _a.setSubmitting,
        setErrors = _a.setErrors,
        setStatus = _a.setStatus;

    try {
      onSubmit(values);
      setSubmitting(false);
      setStatus({
        success: true
      });
    } catch (error) {
      setStatus({
        success: false
      });
      setSubmitting(false);
      setErrors({
        submit: error.message
      });
    }
  };

  return react_1.default.createElement(formik_1.Formik, {
    initialValues: values,
    onSubmit: handleSubmit,
    render: function render(_a) {
      var values = _a.values,
          handleSubmit = _a.handleSubmit,
          isSubmitting = _a.isSubmitting;
      return react_1.default.createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true,
        name: "simpleForm"
      }, includeUser && react_1.default.createElement(react_web_components_1.Section, null, react_1.default.createElement(react_web_components_1.Container, null, react_1.default.createElement("h2", null, "Personuppgifter"), react_1.default.createElement("p", null, "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna \x03aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl."), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "firstName",
        label: t('prop.firstName'),
        placeholder: t('prop.firstName')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "lastName",
        label: t('prop.lastName'),
        placeholder: t('prop.lastName')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "username",
        label: t('prop.email'),
        placeholder: t('prop.email')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "phoneNumber",
        label: t('prop.phoneNumber'),
        placeholder: t('prop.phoneNumber')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        type: "password",
        name: "password",
        label: t('prop.password'),
        placeholder: t('prop.password')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.CheckboxField, {
        label: "Villkor"
      }))))), react_1.default.createElement(react_web_components_1.Section, null, react_1.default.createElement(react_web_components_1.Container, null, react_1.default.createElement("h2", null, "F\xF6retagsuppgifter"), react_1.default.createElement("p", null, "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna \x03aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl."), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "name",
        label: t('prop.name'),
        placeholder: t('prop.name')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "corporateIdentity",
        label: t('prop.corporateIdentity'),
        placeholder: t('prop.corporateIdentity')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "username",
        label: t('prop.email'),
        placeholder: t('prop.email')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "phoneNumber",
        label: t('prop.phoneNumber'),
        placeholder: t('prop.phoneNumber')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "organization.address.street",
        label: t('prop.address'),
        placeholder: t('prop.address')
      }))), react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "organization.address.postalCode",
        label: t('prop.postalCode'),
        placeholder: t('prop.postalCode')
      })), react_1.default.createElement(react_web_components_1.Column, {
        flex: true
      }, react_1.default.createElement(fields_1.InputField, {
        name: "organization.address.city",
        label: t('prop.city'),
        placeholder: t('prop.city')
      }))), react_1.default.createElement(fields_1.InputField, {
        name: "description",
        label: t('prop.description'),
        placeholder: t('prop.description')
      }), react_1.default.createElement("p", {
        style: {
          textAlign: 'center'
        }
      }, "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna \x03aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl."), react_1.default.createElement(react_web_components_1.Row, {
        justify: "center"
      }, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_1.Button, {
        raised: true,
        type: "submit"
      }, t(isSubmitting ? 'action.saving' : 'action.save')))))));
    }
  });
};